// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__17nx1","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__10Wrr"};